import React from 'react';
import {Container} from "react-bootstrap";

function About() {
  return (
    <Container>
      <h1>About iStore</h1>
      <p className="intro-text1">Renewable Energy is, and should be at the forefront of everyone’s thoughts these days.
        Renewables are undoubtedly the way of the future, and, here in Australia we should not ignore our most obvious
        natural asset, solar energy.</p>

      <p>Solar energy is now more affordable, adaptable and powerful than ever.</p>

      <p>iStore - Air to Energy has a proven reputation built on respect as an industry leader in heat pump technology
        dealing direct with qualified trade customers, and sharing our vision for a cleaner more energy efficient
        Australia.</p>

      <p>With over 30 years of solar hot water experience, iStore has established ourselves as a trusted name in the
        industry, providing efficient and effective hot water solutions to both businesses and homes across
        Australia.</p>

      <p>Our journey began a decade ago, when our team of passionate plumbers and electricians set out to develop a heat
        pump that would revolutionise the industry. Driven by a commitment to innovation and sustainability, we knew
        that there was a better way to provide hot water in a more cost effective way to buildings and more importantly,
        homes.</p>

      <p>After years of research and development, we launched our first iStore 270L unit, this was followed by our
        iStore 180L unit which quickly became a game-changer in the industry.</p>

      <p>Our iStore heat pumps combine cutting edge design by our team right here in Australia with market knowledge and
        advanced technology, hence enabling iStore to operate at maximum efficiency, using minimal energy and reducing
        carbon emissions. We knew our team had created something special, and our customers agree.</p>

      <p>Over the years, we have not only continued to refine and improve our heat pump technology but we have
        established our own service department whom of course know the product inside out.</p>

      <p>At iStore we are constantly keeping ahead of the curve and adapting to the changing needs of our customers hot
        water demands. Today, our iStore air to energy heat pumps are among the most efficient and reliable on the
        market, particularly due to our back up army of qualified trade services and the iStore service department.</p>

      <p>Our market leading 5 year comprehensive warranty including labour and parts is a prime example of iStore
        backing our products in the Australian marketplace. We are proud to offer a range of models and configurations
        to suit any business or home hot water requirements.</p>

      <p>At iStore we are not satisfied to rest on our success and are constantly looking to improve. We know that the
        future of the industry lies in innovation and sustainability, and we are committed to leading the way. Our team
        of experts is continually working on new technologies and developing new features to make our heat pumps even
        more efficient, reliable, and sustainable, and we are excited to continue pushing the boundaries on behalf of
        our customers.</p>

      <p>When you choose iStore please be assured that we look forward to continuing to serve your hot water needs, not
        just now, but throughout the future.</p>
      <p>Don't take our word for it. Please take a look at these testimonials</p>
      <p><span style={{color: '#535353'}}>
        <a rel="noreferrer" href="https://installedtoday.com.au/blogs/buying-guides/product-review-istore-270l-heat-pump" target="_blank">
          Product Review - iStore 270L Heat Pump
        </a> and the critical review&nbsp;
        <a rel="noreferrer" href="https://www.jrgasandwater.com.au/blogs/critical-hot-water-system-product-reviews/critical-review-istore-270l-heat-pump-hot-water-system" target="_blank">
          iStore 270L Heat Pump Hot Water System – JR Gas and Water</a>
        <br/></span></p>
    </Container>
  );
}

export default About;